import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Video from '../Video';

const VideoContainer = () => {
  return <Video />;
};

export default VideoContainer;
